import styled from 'styled-components';

export default styled.div`
  /* Firefox */
  scrollbar-color: rgba(98, 106, 146, 0.85) rgba(250, 250, 253, 0); /* thumb and track color */
  scrollbar-width: thin;

  /*webkit-based  browsers*/
  &::-webkit-scrollbar {
    width: 1rem;
  }

  &::-webkit-scrollbar:horizontal{
    height: 1rem;
  }

  &::-webkit-scrollbar-track {
    background: transparent; 
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(98, 106, 146, 0.85);
    border-radius: 0.6rem;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgb(98,106,146);
  }
`;